export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-time-line',
      title: '24/7 Emergency Response',
      description: 'We are available around the clock to respond to your water damage emergency. Our team arrives quickly to minimize damage and begin restoration immediately.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully licensed, bonded, and insured for your protection. Our technicians are IICRC certified and trained in the latest restoration techniques.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Advanced Equipment',
      description: 'We use state-of-the-art water extraction, drying, and dehumidification equipment to ensure thorough and efficient restoration.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Insurance Assistance',
      description: 'We work directly with your insurance company to streamline the claims process and ensure you receive the coverage you deserve.'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: 'Our skilled technicians have years of experience handling all types of water damage, from minor leaks to major floods.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Satisfaction',
      description: 'Your satisfaction is our priority. We provide transparent communication and quality workmanship on every project.'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why Choose Rialto Water Restoration?
          </h2>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            When water damage strikes, you need a restoration company you can trust. Here's why property owners throughout Rialto choose us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{reason.title}</h3>
              <p className="text-white/80 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
